import './sidebar.scss';
import { isMobile, isTablet } from '../../assets/js/_mq';

const drawerElement = document.querySelector('[data-init="sidebar"]');
const drawerMobileClass = ['mdc-drawer--modal'];
const drawerDesktopClass = ['mdc-drawer--dismissible', 'mdc-drawer--open'];

let drawer;
let mobileOverlay;

function toggleMobile(event) {
	const matchesMobile = event.matches;

	if (matchesMobile) {
		drawerElement.classList.add(...drawerMobileClass);
		drawerElement.classList.remove(...drawerDesktopClass);

		drawerElement.insertAdjacentElement('afterend', mobileOverlay);
	} else {
		drawerElement.classList.add(...drawerDesktopClass);
		drawerElement.classList.remove(...drawerMobileClass);

		if (mobileOverlay.parentNode) {
			mobileOverlay.parentNode.removeChild(mobileOverlay);
		}
	}

	drawer = window.MDCDrawer.attachTo(drawerElement);
	drawer.open = !matchesMobile;

	// Overwrite MDC doing weird things
	drawerElement.querySelectorAll('[tabindex]').forEach(item => {
		item.removeAttribute('tabindex');
	});

	// Fix timing issue in Safari
	fixInvalidState();
}

function toggleTablet(event) {
	const matchesTablet = event.matches;

	drawer.open = !matchesTablet && !isMobile.matches;
}

function fixInvalidState() {
	setTimeout(() => {
		if (!drawerElement.classList.contains('mdc-drawer--closing')) {
			return;
		}

		const shouldBeOpen =
			!isTablet.matches &&
			!isMobile.matches &&
			window.localStorage.getItem('sidebar') !== 'false';

		drawerElement.classList.remove('mdc-drawer--closing');

		// Wait for next frame
		requestAnimationFrame(() =>
			requestAnimationFrame(() => {
				drawer.open = shouldBeOpen;
			})
		);
	}, 250);
}

if (drawerElement) {
	const toggleElement = drawerElement.querySelector('[data-sidebar="toggle"]');

	mobileOverlay = document.createElement('div');
	mobileOverlay.classList.add('mdc-drawer-scrim');

	isMobile.addListener(toggleMobile);
	toggleMobile(isMobile);

	isTablet.addListener(toggleTablet);
	toggleTablet(isTablet);

	drawerElement.classList.remove('mdc-drawer--loading');

	if (window.localStorage.getItem('sidebar') === 'false') {
		drawer.open = false;
	}

	if (toggleElement) {
		toggleElement.addEventListener('click', () => {
			const newState = !drawer.open;

			drawer.open = newState;

			window.localStorage.setItem('sidebar', newState);
		});
	}
}

export { drawer };
